import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import TOOLBAR_PICTURE from '@tencent/docs-design-resources/icon/desktop/svg/zip_light_24.svg';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';

export const config = {
    id: ActionType.FILE_COMPRESSION,
    tipMsg: i18n.t('文件瘦身'),
    title: i18n.t('文件瘦身'),
    titleForBig: i18n.t('文件瘦身'),
    icon: TOOLBAR_PICTURE,
};

export const TOOLBAR_CONFIGS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.title,
        style: {
        },
    },
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: config.title,
        style: {
        },
    },
];
